module.exports = __webpack_public_path__ + "static/media/5DPO12.276efdd5.jpg";